import { Node as GatsbyNode } from 'gatsby';

export interface MetaData {
  siteName: string;
  siteImage: string;
  description: string;
}

interface Site {
  siteMetadata: MetaData;
}

export enum PageLayout {
  Basic = 'basic',
  Documentation = 'documentation',
  Framework = 'framework',
  InteractiveCode = 'interactive-code',
}

export interface FrontMatter {
  title: string;
  description: string;
  image: string;
  layout: PageLayout;
  canonical?: string;
  redirect?: string;
  sidebarTitle?: string;
  metaTitle?: string;
}

export interface MDXAST {
  type: string;
  depth?: number;
  value?: string;
  children?: MDXAST[];
}

interface File {
  childMdx: {
    frontmatter: FrontMatter;
    body: string;
    mdxAST: MDXAST;
    fields: {
      contentSwitcherValues: string;
    };
  };
}

export interface Data {
  site: Site;
  file: File;
}

export interface MDX {
  internal: {
    type: string;
  };
  frontmatter: FrontMatter;
}

export interface SidebarPage {
  title: string;
  path: string;
  anchor?: boolean;
}

export interface SidebarCategory {
  title: string | null;
  pages: Array<SidebarPage | SidebarCategory>;
  defaultExpanded?: boolean;
  collapsible?: boolean;
}

export type SidebarContent = Array<SidebarPage | SidebarCategory>;

export interface Sidebar {
  category?: string;
  version?: string;
  content: SidebarContent;
}

export type Sidebars = Sidebar[];

export interface Location {
  pathname: string;
  hash: string;
  host: string;
  origin: string;
}

export interface SideBarFileCategory {
  title: string;
  items: Array<string | SideBarFileCategory>;
  // determine if the category is collapsible or always expanded
  collapsible?: boolean;
  // determines if the category should be expanded by default
  defaultExpanded?: boolean;
}

export type SidebarFileContent = Array<string | SideBarFileCategory>;

export interface Node extends GatsbyNode {
  id: string;
  sourceInstanceName: string;
  relativePath: string;
  childMdx: MDX;
}

export interface Edge {
  node: Node;
}

export interface AllFileQuery {
  allFile: {
    edges: Edge[];
  };
}

export type SourcePluginEntry = {
  resolve: string;
  options: { path: string; name: string };
}[];
